<template>
  <div class="staff">
    <header class="view-header">
      <div class="view-header__text">
        <h1 class="view-header__title">Personal</h1>
        <p class="view-header__sub">Gestiona tu equipo y revisa su actividad.</p>
      </div>
    </header>

    <div class="staff__body">
      <!-- left rail (md+) / horizontal-scroll row (mobile) -->
      <aside class="staff__rail">
        <list ref="list" @select="select"></list>
      </aside>

      <!-- detail panel -->
      <section class="staff__detail">
        <detail
          v-if="selected"
          :employee="selected"
          @reload="reloadList"
          @deleted="reloadList"
        ></detail>

        <div v-else class="staff__empty">
          <div class="staff__empty-icon">
            <hero-icon :icon="UsersIcon" :size="26" />
          </div>
          <p class="staff__empty-title">Selecciona un miembro del personal</p>
          <p class="staff__empty-sub">
            Elige a alguien de tu equipo para ver su actividad y editar sus datos.
          </p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import List from "@/components/staff/List";
import Detail from "@/components/staff/Detail";
import HeroIcon from "@/components/shared/HeroIcon";
import UsersIcon from "heroicons/24/outline/users.svg";

export default {
  data: () => ({
    UsersIcon,
    selected: null
  }),

  methods: {
    select(employee) {
      this.selected = employee;
    },

    // after an avatar update or a delete, refetch the rail (network-only); List
    // re-resolves the selection by id (or falls back to the first member), which
    // re-emits @select and refreshes this pane — no full SPA reload.
    reloadList() {
      this.$refs.list.fetchStaff("network-only");
    }
  },

  components: {
    List,
    Detail,
    HeroIcon
  }
};
</script>

<style scoped>
.staff {
  background: #f7f5f1;
  min-height: 100%;
}

/* ----- warm view header ----- */
.view-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
}
.view-header__title {
  font-size: 26px;
  font-weight: 700;
  line-height: 1.1;
  color: #1a1814;
  margin: 0;
}
.view-header__sub {
  font-size: 13.5px;
  color: #756f64;
  margin: 5px 0 0;
}

/* ----- master-detail body (md+) ----- */
.staff__body {
  display: grid;
  grid-template-columns: 260px minmax(0, 1fr);
  gap: 20px;
  align-items: start;
}

.staff__rail {
  min-width: 0;
}

.staff__detail {
  min-width: 0;
}

/* ----- empty / placeholder state ----- */
.staff__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: #faf8f4;
  border: 1px solid #ece7de;
  border-radius: 12px;
  box-shadow: 0 8px 24px -16px rgba(40, 33, 22, 0.18);
  padding: 56px 28px;
  min-height: 320px;
}
.staff__empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 999px;
  background: #f1ece3;
  color: #756f64;
  margin-bottom: 16px;
}
.staff__empty-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a1814;
  margin: 0;
}
.staff__empty-sub {
  font-size: 13.5px;
  color: #756f64;
  margin: 6px 0 0;
  max-width: 340px;
}

/* ----- mobile: rail collapses above the detail ----- */
@media (max-width: 959.98px) {
  .staff__body {
    display: block;
  }
  .staff__rail {
    margin-bottom: 16px;
  }
}
</style>
